// Base configuration for different types of items
const itemTypes = {
  components: {
    getItems() {
      return this.getComponents()
    },
    updatePath: ['components'],
    validateKey: () => true,
    getItemTypeName: () => 'components'
  },
  pages: {
    getItems() {
      return this.getData('pages')
    },
    updatePath: ['pages'],
    validateKey: (key) => key.startsWith('/'),
    getItemTypeName: () => 'pages',
    validationError: "Page's key must start with /"
  },
  functions: {
    getItems() {
      return this.getFunctions()
    },
    updatePath() {
      return [this.call('getType')]
    },
    validateKey: () => true,
    getItemTypeName() {
      return this.call('getType')
    }
  },
  files: {
    getItems() {
      return this.getFiles()
    },
    updatePath: ['files'],
    validateKey: (key, originalFormat) => {
      const [, newFormat] = key.split('.')
      return !newFormat || newFormat === originalFormat
    },
    validationError:
      'This format is different from the original. Please maintain the same format or omit it to reuse.',
    formatKey: (key, originalFormat) => {
      const [, newFormat] = key.split('.')
      return newFormat ? key : `${key}.${originalFormat}`
    },
    getItemTypeName() {
      return 'files'
    }
  }
}

function showError(errorEl, text) {
  errorEl.update({
    display: 'block!important',
    text
  })

  setTimeout(() => {
    errorEl.update({
      display: '',
      text: ''
    })
  }, 2500)
}

export async function renameLegacy(
  type,
  inputName = 'new-key',
  callback = () => null
) {
  const typeConfig = itemTypes[type]

  if (!this.node.elements) {
    console.warn(
      `rename${type.charAt(0).toUpperCase() + type.slice(1)} must be used on submit of a Form`
    )
    return
  }

  const { state: s } = this
  let newKey = this.node.elements.item(inputName).value
  const items = typeConfig.getItems.call(this)
  const errorEl = this.lookup('Label').Err

  const handleError = (text) => {
    showError(errorEl, text)
    this.node.reset()
  }

  if (items[newKey]) {
    handleError(
      `${typeConfig.getItemTypeName.call(this)} with such key exists. Please enter a new key`
    )
    return
  }

  if (
    typeConfig.validateKey &&
    !typeConfig.validateKey(newKey, s.value.format)
  ) {
    handleError(typeConfig.validationError)
    return
  }

  if (typeConfig.formatKey) {
    newKey = typeConfig.formatKey(newKey, s.value.format)
  }

  this.call('rename', s.type, s.key, newKey)

  // const updatePath = this.call('isFunction', typeConfig.updatePath)
  //   ? typeConfig.updatePath.call(this)
  //   : typeConfig.updatePath

  // const factoryType = updatePath[0]
  // const schema = this.getSchema(factoryType)
  // const hasSchema = schema && schema[s.key]

  // if (hasSchema && hasSchema.key) {
  //   hasSchema.key = newKey
  // }

  // this.sdk.updateData(
  //   [
  //     ['delete', [...updatePath, s.key]],
  //     ['update', [...updatePath, newKey], s.value],
  //     hasSchema && ['delete', ['schema', ...updatePath, s.key]],
  //     hasSchema && ['update', ['schema', ...updatePath, newKey], hasSchema]
  //   ].filter((v) => v),
  //   {
  //     message: `Rename ${typeConfig.getItemTypeName.call(this)} from ${
  //       s.key
  //     } to ${newKey}`
  //   }
  // )

  window.requestAnimationFrame(() => callback(newKey))
}

export async function renameComponents(
  inputName = 'NewKey',
  callback = () => null
) {
  return await this.call('renameLegacy', 'components', inputName, callback)
}

export async function renamePages(
  inputName = '/new-key',
  callback = () => null
) {
  return await this.call('renameLegacy', 'pages', inputName, callback)
}

export async function renameFunctions(
  inputName = 'newKey',
  callback = () => null
) {
  return await this.call('renameLegacy', 'functions', inputName, callback)
}

export async function renameFiles(
  inputName = 'new-key',
  callback = () => null
) {
  return await this.call('renameLegacy', 'files', inputName, callback)
}
